// Each entry carries:
//   bg / color — the BRIGHT filled tile used on the canvas nodes (unchanged).
//   accent     — the vivid identity color. The sidebar derives its dark
//                "tinted tile + colored glyph" look from this (low-opacity
//                tint background + full-color glyph).
var SYSTEM_OBJECT_THEME = {
  start: {
    bg: '#aee7cc',
    color: '#142320',
    accent: '#52d896'
  },
  agent: {
    bg: '#7f96b8',
    color: '#ffffff',
    accent: '#60a5fa'
  },
  'tool-agent': {
    bg: '#7f96b8',
    color: '#ffffff',
    accent: '#60a5fa'
  },
  'computer-use': {
    bg: '#8eb9a7',
    color: '#11241c',
    accent: '#74c39a'
  },
  classifier: {
    bg: '#f5c452',
    color: '#2a1f08',
    accent: '#eab308'
  },
  router: {
    bg: '#e89b5e',
    color: '#2a1508',
    accent: '#fb923c'
  },
  condition: {
    bg: '#f5c452',
    color: '#2a1f08',
    accent: '#eab308'
  },
  loop: {
    bg: '#f5c452',
    color: '#2a1f08',
    accent: '#eab308'
  },
  sleep: {
    bg: '#f5c452',
    color: '#2a1f08',
    accent: '#eab308'
  },
  'file-preview': {
    bg: '#f4d756',
    color: '#2c2508',
    accent: '#eab308'
  },
  'console-log': {
    bg: '#cacacf',
    color: '#242428',
    accent: '#94a3b8'
  },
  'browser-run': {
    bg: '#7f96b8',
    color: '#ffffff',
    accent: '#7c93ee'
  },
  'browser-action': {
    bg: '#7f96b8',
    color: '#ffffff',
    accent: '#7c93ee'
  },
  'browser-agentic-action': {
    bg: '#a08fd8',
    color: '#ffffff',
    accent: '#a78bfa'
  },
  apify: {
    bg: '#a7e8d5',
    color: '#0b2c24',
    accent: '#12b886'
  },
  variables: {
    bg: '#6f8fb2',
    color: '#ffffff',
    accent: '#8b7cf2'
  },
  'set-variable': {
    bg: '#5ba8a0',
    color: '#ffffff',
    accent: '#2dd4bf'
  },
  'flow-ref': {
    bg: '#7dd3fc',
    color: '#062430',
    accent: '#56c5f5'
  },
  'on-fail': {
    bg: '#eda4a4',
    color: '#2a0d0d',
    accent: '#ef4444'
  },
  custom: {
    bg: '#a08fd8',
    color: '#ffffff',
    accent: '#a78bfa'
  }
};

function getSystemObjectTheme(type) {
  return SYSTEM_OBJECT_THEME[type] || null;
}

module.exports = {
  getSystemObjectTheme: getSystemObjectTheme
};
